import { combineClassNames } from '@common/utils/combineClassNames';
import React from 'react';

require('./form-icon.scss');

type Props = {
  form: Record<string, any> & Partial<{
    color: string;
    icon: string;
  }>;
  className?: string;
  iconClassName?: string;
};

export const FormIcon = ({ form, className, iconClassName }: Props) => {
  if (!form?.icon) return null;

  return (
    <div className={combineClassNames('FormIcon', iconClassName)} style={{ backgroundColor: form.color }}>
      <img
        src={form.icon.startsWith('https://')
          ? form.icon
          : `https://assets.oneteam.io/globals/attachments/${form.icon}`}
        alt="Icon"
        className={className}
      />
    </div>
  );
};
